// @flow

// Effect Managers
import { take, put, select } from 'redux-saga/effects'

// Constants
import { PRESELECTED_JOB } from '../constants'

// Actions
import { updateFarm, updateField } from 'hfty-assets'
import { updateCurrentSeason } from 'hfty-seasons'
import { selectSoilJob } from 'hfty-soil-jobs-dom/src/actions'
import { preselectedJobSet } from 'hfty-map-dom'

// Selectors
import { selectedJob } from 'hfty-soil-jobs/src/selectors/selectedJob'
import getAssetObject from 'hfty-assets/src/selectors/getAssetObject'
import selectedFarmId$ from 'hfty-map/src/selectors/selectedFarmId'

// Controllers
import jobsCtrl from 'fc-ctrl-sampling-jobs'
import assetsCtrl from 'fc-ctrl-assets'

export default function *watchPreselectedJob (): Generator<*, *, *> {
  while (true) {
    const { jobId } = yield take(PRESELECTED_JOB)
    let jobObject = yield select(selectedJob(jobId))

    while (!jobObject) {
      yield take(jobsCtrl.actionTypes.receive())
      jobObject = yield select(selectedJob(jobId))
    }

    const farmId = jobObject.farm
    const fieldId = jobObject.field
    let fieldObject = yield select(getAssetObject(fieldId))

    while (!fieldObject) {
      yield take(assetsCtrl.actionTypes.receive())
      fieldObject = yield select(getAssetObject(fieldId))
    }

    const seasonId = fieldObject.season

    yield put(updateCurrentSeason(seasonId))
    const currentFarmId = yield select(selectedFarmId$)
    if (farmId !== currentFarmId) {
      // avoid updating farm to env twice
      yield put(updateFarm(farmId))
    }
    yield put(updateField(fieldId))
    yield put(selectSoilJob(jobId))
    yield put(preselectedJobSet(fieldId))
  }
}
